import { calculateDistance } from "../../utils/geom"
import { getGeometryDimensions, getProjectedDistance } from "../utils"
import { MapMeasuringServiceWgs84 } from "./svc-wgs84"
import { IMapMeasuringService } from "./types"
import { ol_Coordinate, ol_extent, ol_Feature, ol_Extent, ol_geom, ol_proj } from "@omnia/exports/openlayers";

const extents = [
    {
        srid: "EPSG:27700",
        extent: [-981840, 6409980, 213740, 8612070]
    }
]

/** @internal */
export class MapMeasuringService implements IMapMeasuringService {

    private readonly wgs84 = new MapMeasuringServiceWgs84()

    constructor() {
    }

    getDistance(c1: ol_Coordinate, c2: ol_Coordinate, sourceProj = "EPSG:3857"): number {

        const prj = findExtentForCoords([c1, c2])

        if (!prj) {
            return this.wgs84.getDistance(c1, c2, sourceProj)
        }

        c1 = ol_proj.transform(c1, sourceProj, prj)
        c2 = ol_proj.transform(c2, sourceProj, prj)

        const length = calculateDistance(c1, c2)

        return length

    }


    getArea(geometry: ol_geom.Geometry | ol_Feature, sourceProj: string = "EPSG:3857") {
        return this.getDimensions(geometry, sourceProj).area
    }

    getLength(geometry: ol_geom.Geometry | ol_Feature, sourceProj: string = "EPSG:3857"): number {
        return this.getDimensions(geometry, sourceProj).length
    }

    getDimensions(geometry: ol_geom.Geometry | ol_Feature, sourceProj: string = "EPSG:3857") {

        const prj = findExtentForGeometry(geometry)

        if (!prj) {
            return this.wgs84.getDimensions(geometry, sourceProj)
        }

        return getGeometryDimensions(geometry, prj, sourceProj)

    }

    getProjectedDistance(center: ol_Coordinate, distance: number, sourceProj: string = "EPSG:3857"): number {

        const [x, y] = center

        // This is just a rough approximation - this should rather use a circle,
        // but is really not worth it in this context
        const area = [
            x - distance,
            y - distance,
            x + distance,
            y + distance
        ]

        const prj = findExtentForExtent(area)

        if (!prj) {
            return this.wgs84.getProjectedDistance(center, distance, sourceProj)
        }

        return getProjectedDistance(center, distance, sourceProj, prj)

    }

}


function findExtentForCoords(coords: ol_Coordinate[]) {

    return extents.find(e => coords.every(c => ol_extent.containsCoordinate(e.extent, c)))?.srid

}

function findExtentForGeometry(arg: ol_geom.Geometry | ol_Feature) {

    const extent = arg instanceof ol_Feature
        ? arg.getGeometry().getExtent()
        : arg.getExtent()

    return findExtentForExtent(extent)

}

function findExtentForExtent(extent: ol_Extent) {

    return extents.find(e => ol_extent.containsExtent(e.extent, extent))?.srid

}
